<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ProgressBar from '../UI/ProgressBar.vue'

withDefaults(
  defineProps<{
    value: number
    total: number
    remaining: number
    client?: boolean
    inherited: boolean
  }>(),
  { client: false },
)

const { n, t } = useI18n()
</script>

<template>
  <div class="row align-items-center">
    <div class="col-12 col-xl-6 d-flex align-items-center">
      <div :class="{ 'flex-grow-1': true, client: client }">
        <ProgressBar :value="value" :max="total" :exceeded="remaining <= 0" />
      </div>
      <div class="ml-1">
        <small :class="{ invisible: !inherited }">
          <i class="far fa-question-circle" :title="t('home.dashboardFundingEnvelope.inherited')"></i>
        </small>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <div class="ml-0 ml-xl-1">
        <small class="no-wrap">{{ n(value, 'currency') }} / {{ n(total, 'currency') }}</small>
      </div>
    </div>
  </div>
</template>

<style scoped>
.client :deep(.progress-bar.bg-info) {
  background-color: var(--color-info-lighter) !important;
  color: var(--color-dark) !important;
}
</style>
